import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { useParams, useNavigate } from 'react-router-dom'

import Header from '@pages/companies/header'
import ArrowBack from '@components/arrowBack'
import Card from '@components/card'

import { getDateStringFromUsableDateStrWithoutSecond } from '@util/timeUtil'

import { getMessage as getMessageAction } from '@actions/notification'

import {
  ContentContainer,
  TitleContainer,
  Container,
  BoldTitle,
  SubTitle,
  OriginCard,
  OriginText,
  CardHeader,
  Title,
  BeneficiariesContainer,
  Content,
} from './styles'

import colors from '@settings/styleSettings'

import _ from 'lodash'

const MessageInfos = ({ message, getMessage }) => {
  const [loading, setLoading] = useState(false)
  const { messageId } = useParams()
  const getRecipient = () => {
    if (message?.companyName) {
      return `da empresa ${message.companyName}`
    }
    if (message?.programmeName) {
      return `do programa ${message.programmeName}`
    }
    return 'da Unimed Assis'
  }
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    messageId && getMessage(messageId, () => setLoading(false))
  }, [messageId])

  const getOriginCardColor = (msg) => {
    if (msg.companyName || msg.programmeName) {
      return [colors.strongBlue, colors.softBlue]
    }
    return [colors.strongGreen, colors.softGreen]
  }

  return (
    <Container>
      <Header />
      {message && !loading && (
        <TitleContainer>
          <ArrowBack
            onClick={() => {
              navigate(-1)
            }}
          />
          <BoldTitle>{message && message.typeMessage}</BoldTitle>
          <SubTitle>
            {`Enviado por ${
              message.senderName
            } em ${getDateStringFromUsableDateStrWithoutSecond(
              message.sentAt
            )}`}
          </SubTitle>
          <OriginCard color={getOriginCardColor(message)}>
            <OriginText>
              {message?.companyName || message?.programmeName
                ? message.companyName || message.programmeName
                : 'Geral'}
            </OriginText>
          </OriginCard>
          <Card>
            <CardHeader>
              <Title>Destinatários</Title>
              <BeneficiariesContainer>
                {message.global
                  ? `Mensagem enviada para todos os beneficiátios ${getRecipient()}.`
                  : _.map(message.beneficiaryNames, (n, index) => (
                    <OriginCard
                      key={index}
                      color={[colors.titleStrongBlack, colors.grayBackground]}
                    >
                      <OriginText>{n}</OriginText>
                    </OriginCard>
                  ))}
              </BeneficiariesContainer>
            </CardHeader>
            <ContentContainer>
              <Title>Conteúdo</Title>
              <Content>{message.message}</Content>
            </ContentContainer>
          </Card>
        </TitleContainer>
      )}
    </Container>
  )
}

MessageInfos.propTypes = {
  message: PropTypes.shape({
    beneficiaryNames: PropTypes.array,
    companyName: PropTypes.string,
    global: PropTypes.bool,
    id: PropTypes.number,
    message: PropTypes.string,
    programmeName: PropTypes.string,
    sendType: PropTypes.string,
    senderName: PropTypes.string,
    sentAt: PropTypes.string,
    totalBeneficiaries: PropTypes.number,
    typeMessage: PropTypes.string,
  }),
  getMessage: PropTypes.func.isRequired,
}

MessageInfos.defaultProps = {
  message: null
}

const mapStateToProps = ({ notification }) => ({
  message: notification.message,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getMessage: getMessageAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(MessageInfos)
